export const Experience = {
  id: 'Experience',
  lightBg: true,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Experience',

  description:
    "Feel free to click the button below to download my resume and take a better look at my accomplishments and projects I've worked on.",
  headline: 'Resume',
  buttonLabel: 'Download Resume',
  imgStart: true,
  img: require('../../images/Resume.jpg'),
  alt: 'Resume',
  dark: true,
  primary: true,
  darkText: false
};
